import * as Yup from "yup";

export const selectPickupSlotSchema = Yup.object().shape({
    selected_slot: Yup.object().shape({
        value: Yup.string().required("Please Select Slot").nullable()
    }).nullable().required("Please Select Slot")
});